import { Dispatch } from '../../common/state';
import { setTermValue } from './advanced/term';

export function changeFromOffRep(value: boolean | undefined) {
  return (dispatch: Dispatch) => {
    dispatch(setTermValue('from_offrep', value || undefined));
  };
}
